export var TENANTS = {
    NORDSECURITY: 'nordsec',
    CYBERCARE: 'cybercare'
};
